<h1 mat-dialog-title>Capture waybill</h1>
<div mat-dialog-content>
  <mat-form-field appearance="outline" class="w-100 mb-3">
    <mat-label>Search by Order No</mat-label>
    <input
      matInput
      #searchBox
      placeholder="Enter order number..."
      type="number"
      (input)="onSearchChange(searchBox.value)"
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    @if (!waybillCompleted) {
      <mat-stepper linear #stepper>
        <mat-step>
          <mat-card class="prescription-list-container">
            <table
              mat-table
              [dataSource]="ordersDataSource"
              matSort
              (matSortChange)="sortOrders($event)"
              class="prescription-list"
              >
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>#</th>
                <td mat-cell *matCellDef="let order">
                  @if (
                    !searchBox.value ||
                    order.id.toString().includes(searchBox.value)
                    ) {
                    <span
                      >
                      {{ order.id }}
                    </span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let order">
                  @if (
                    !searchBox.value ||
                    order.id.toString().includes(searchBox.value)
                    ) {
                    <span
                      >
                      {{ getEntityName(order) }}
                    </span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let order">
                  @if (
                    !searchBox.value ||
                    order.id.toString().includes(searchBox.value)
                    ) {
                    <span
                      class="badge {{ getBadgeBackground(order.status) }}"
                      >
                      {{ order.status.status }}
                    </span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="contact">
                <th mat-header-cell *matHeaderCellDef>Contact</th>
                <td mat-cell *matCellDef="let order">
                  @if (
                    !searchBox.value ||
                    order.id.toString().includes(searchBox.value)
                    ) {
                    <span
                      >
                      {{ getOwnerPhoneNumber(order) }}
                    </span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef>Created</th>
                <td mat-cell *matCellDef="let order">
                  @if (
                    !searchBox.value ||
                    order.id.toString().includes(searchBox.value)
                    ) {
                    <span
                      >
                      {{ getCreationTime(order) }}
                    </span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="updated_at">
                <th mat-header-cell *matHeaderCellDef>Updated</th>
                <td mat-cell *matCellDef="let order">
                  @if (
                    !searchBox.value ||
                    order.id.toString().includes(searchBox.value)
                    ) {
                    <span
                      >
                      {{ formatTime(order.updated_at) }}
                    </span>
                  }
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let order; columns: displayedColumns"
                (click)="openOrder(order)"
              ></tr>
            </table>
            <div class="pagination-controls">
              <button mat-button (click)="goToPreviousPage()" [disabled]="page === 1">
                Previous
              </button>
              <span>Page {{ page }} of {{ paginator?.getNumberOfPages() || 1 }}</span>
              <button mat-button (click)="goToNextPage()" [disabled]="page >= paginator.getNumberOfPages()">
                Next
              </button>
            </div>
            <mat-paginator
              #paginator
              [length]="totalNumberOfOrders"
              [pageSize]="limit"
              [pageSizeOptions]="[5, 10, 25, 50]"
              (page)="onPageChange($event)">
            </mat-paginator>
          </mat-card>
        </mat-step>
        <mat-step>
          <p>
            Please confirm order will be shipped with order number :
            {{ fetchedOrder?.id }}
          </p>
          <div class="my-2 text-end">
            <button
              class="me-2"
              matStepperPrevious
              mat-raised-button
              color="primary"
              >
              <mat-icon>chevron_left</mat-icon> Previous
            </button>
            <button
              (click)="editOrder()"
              mat-raised-button
              mat-dialog-close
              color="primary"
              >
              Capture waybill
            </button>
          </div>
        </mat-step>
      </mat-stepper>
    }
  </div>
  <div mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
  </div>
